import styled from 'styled-components';
import { withTheme } from '@dls/web';

const ProductDetailsWrapper = withTheme(styled.div`
  margin-top: 0;
`);

export { ProductDetailsWrapper };
